import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="risk-adjustment-form"
export default class extends Controller {
  static targets = ["rangeFields", "matchField"]

  connect() {
    this.updateFields()
    console.log("RiskAdjustmentFormController connected")
  }

  updateFields() {
    const categorySelect = this.element.querySelector('select[name="risk_adjustment[category]"]')
    if (!categorySelect) return

    const category = categorySelect.value

    // Categories that use range fields (min_value/max_value)
    const rangeCategories = ['credit_score', 'ltv_tier', 'community_risk']

    // Categories that use match fields (match_value)
    const matchCategories = ['location', 'mortgage_position', 'broker_trust', 'borrower_character', 'property_condition', 'property_type']

    if (rangeCategories.includes(category)) {
      this.showRangeFields()
      this.hideMatchField()
    } else if (matchCategories.includes(category)) {
      this.hideRangeFields()
      this.showMatchField()
    } else {
      // No category selected yet
      this.hideRangeFields()
      this.hideMatchField()
    }
  }

  showRangeFields() {
    if (this.hasRangeFieldsTarget) {
      this.rangeFieldsTarget.style.display = 'grid'
    }
  }

  hideRangeFields() {
    if (this.hasRangeFieldsTarget) {
      this.rangeFieldsTarget.style.display = 'none'
    }
  }

  showMatchField() {
    if (this.hasMatchFieldTarget) {
      this.matchFieldTarget.style.display = 'block'
    }
  }

  hideMatchField() {
    if (this.hasMatchFieldTarget) {
      this.matchFieldTarget.style.display = 'none'
    }
  }
}